











import { Component, Vue } from 'vue-property-decorator'
import VersionService from '@/service/VersionService'
import { LoginStateModule } from '@/store/modules/LoginStateModule'
import { BadgeStateModule } from '@/store/modules/BadgeStateModule'
import KeepAliveService from '@/service/KeepAliveService'
import BadgeService from '@/service/BadgeService'
import HeaderComponent from '@/components/HeaderComponent.vue'
import NaviComponent from '@/components/NaviComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

@Component({
  components: {
    HeaderComponent,
    NaviComponent,
    BreadcrumbsComponent,
    FooterComponent,
  },
})
export default class App extends Vue {
  versionService = VersionService.instance
  keepAliveService = KeepAliveService.instance
  badgeService = BadgeService.instance

  /** ナビゲーションメニュー表示制御 */
  drawer = false

  created() {
    /* セッションストレージを空にする */
    this.clearSessionStorage()
  }

  mounted () {
    const localVersion = localStorage.getItem("version")
    this.versionService.getVersion()
      .then(serverVersion => {
        if (localVersion === null) {
          /* バージョン情報セット */
          localStorage.setItem("version", serverVersion)
        } else if (localVersion !== serverVersion) {
          /* serviceWorkerの登録削除 */
          if (window.navigator.serviceWorker !== undefined) {
            window.navigator.serviceWorker.getRegistrations()
              .then(registrations => registrations.forEach(x => x.unregister()))
          }
          /* リロード */
          localStorage.setItem("version", serverVersion)
          window.location.reload()
        }
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
      })
    
    /* セッションキープ */
    this.startKeepAlive()
    
    /* バッジ情報の更新 */
    this.startBadgeUpdate()
  }

  destroyed() {
    /* セッションストレージを空にする */
    this.clearSessionStorage()
  }

  /**
   * セッションストレージを空にする
   */
  private clearSessionStorage() {
    sessionStorage.clear()
  }

  /**
   * セッションキープ
   */
  private startKeepAlive() {
    setInterval(() => {
      this.keepAliveService.keepAlive()
    }, 1000 * 60 * 5)
  }

  /**
   * バッジ情報の更新
   */
  private startBadgeUpdate() {
    setInterval(() => {
      if (LoginStateModule.isLogin) {
        /* ログイン中の場合、バッジ情報を取得 */
        this.badgeService.info()
          .then(x => {
            BadgeStateModule.setBadge(x)
          })
          .catch(error => {
            // eslint-disable-next-line
            console.log(error)
          })
      }
    }, 1000 * 60)
  }

}
